import React from "react";
import "./FilterControls.css";

const FilterControls = ({
  searchQuery,
  setSearchQuery,
  statusFilter,
  setStatusFilter,
  stateFilter,
  setStateFilter,
  availableStates,
}) => {
  return (
    <div className="filter-controls">
      <div className="search-box">
        <input
          type="text"
          placeholder="Search by vehicle number..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-input"
        />
        {searchQuery && (
          <button
            className="clear-search"
            onClick={() => setSearchQuery("")}
            aria-label="Clear search"
          >
            ✕
          </button>
        )}
      </div>

      <div className="filter-buttons">
        <button
          className={`filter-btn ${statusFilter === "all" ? "active" : ""}`}
          onClick={() => setStatusFilter("all")}
        >
          All Vehicles
        </button>
        <button
          className={`filter-btn ${statusFilter === "moving" ? "active" : ""}`}
          onClick={() => setStatusFilter("moving")}
        >
          Moving
        </button>
        <button
          className={`filter-btn ${statusFilter === "stopped" ? "active" : ""}`}
          onClick={() => setStatusFilter("stopped")}
        >
          Stopped
        </button>
      </div>

      {/* State Filter Dropdown */}
      <div className="state-filter">
        <select
          value={stateFilter}
          onChange={(e) => setStateFilter(e.target.value)}
          className="state-select"
        >
          <option value="all">All States</option>
          {availableStates.map((state) => (
            <option key={state} value={state}>
              {state}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default FilterControls;
